export default "__VITE_ASSET__Yuuh4toC__"